import { Notificacion, NotificacionExtendida } from "@components/general/Alertas/Alertas";
import UserContext from "@context/User/UserContext";
import useForm from "@customHooks/useForm";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dashboardRoutesPaths from "@helpers/dashboardRoutesPaths/dashboardRoutesPaths";
import { validateCodigoDescuentoConvenio } from "@helpers/httpRequests/httpRequestConvenios/httpRequestConvenios";
import { createCheckoutSession, createPaymentIntent, getFolioContratoCompra, getFolioContratoLecturaVeloz, updatePaymentIntentPlan, validateCodigoDescuento } from "@helpers/httpRequests/httpRequestsPagos/httpRequestsPagos";
import FormularioNuevaCompra from "@helpers/paymentIntent/FormularioNuevaCompra";
import stripe from "@helpers/stripe/stripe";
import { typesOpcionesPagoCompra } from "@helpers/types/typesOpcionesPagoCompra";
import { FormControl as MUIFormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, FormControl, Image, InputGroup, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NotificationManager } from "react-notifications";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import Swal from "sweetalert2";

const setPrecio = (codigoDescuento, precios, setPreciosXCodigo) => {
	console.log(precios);
	console.log(codigoDescuento)
	switch (codigoDescuento) {
		case precios.clickPlus2024.codigo:
			setPreciosXCodigo(precios.clickPlus2024);
			break;

		case precios.clickPlusPremium.codigo:
			setPreciosXCodigo(precios.clickPlusPremium);
			break;

		case precios.gcPlus.codigo:
			setPreciosXCodigo(precios.gcPlus);
			break;

		case precios.clickPlusMasterClass.codigo:
			setPreciosXCodigo(precios.clickPlusMasterClass);
			break;

		case precios.lecturaVelozUveg.codigo:
			setPreciosXCodigo(precios);
			break;


		default:
			console.log(codigoDescuento)
			console.log(precios.clickPlusMasterClass.codigo)
			console.log("No hay ningún código que coincida con el ingresado o no se ingresó ningún dato");
			break;
	}
};

// const esConvenio = (convenio) => {
// 	switch (convenio) {
// 		case '25080401':
// 			return 160000;
			
	
// 		default:
// 			return 299000;
// 	}
// }

function esValido(json) {
	return Object.keys(json).length > 0;
}


const FormCodigoDescuento = (props) => {

	const {t} = useTranslation();

	const {
		precios,
		compraExterna,
		states: { stateCodigoAplicado, stateCodigoDescuento, statePreciosXCodigo },
		compraLectura,
	} = props;


	const history = useHistory();

	const { contextValue, setContextValue } = useContext(UserContext);
	
	const {compra} = contextValue;

	const { codigoAplicado, setCodigoAplicado } = stateCodigoAplicado;

	const { codigoDescuento, setCodigoDescuento } = stateCodigoDescuento;
	
	const [convenio, setCodigoConvenio] = useState(compra.codigoConvenio !== '' ? compra.codigoConvenio : null  );

	const { preciosXCodigo, setPreciosXCodigo } = statePreciosXCodigo;

	const [idCodigoDescuento, setIdCodigoDescuento] = useState(compraLectura ? 4 : 0);

	const [folioContrato, setFolioContrato] = useState("");

	const [loading, setLoading] = useState(false);

	const [opcionesPago, setOpcionesPago] = useState([]);

	const [valueRadioButton, setValueRadioButton] = useState("");

	const [urlParams, setUrlParams] = useState({
		urlParamsSuccess: "",
		urlParamsCancel: "",
	})

	const [inputValue, handleInputChange] = useForm("");

	const handleSubmitValidacionCodigo = async (e) => {
		e.preventDefault();

		if (inputValue === "") {
			return NotificationManager.error("Ingresa un código de descuento");
		}

		let auxCodigo = compraLectura ? 4 : inputValue;

		if(convenio){
			//Validar el codigo de descuento recuperand el codigo de descuento
				try {
					console.log(inputValue);
					const results = await validateCodigoDescuentoConvenio(inputValue);
					console.log(results);

					auxCodigo = 'LECTURA_UVEG';

				} catch (error) {
					
					return NotificationManager.error("Este código es inválido");
				}
			//
		}

		try {
			const { valido, idCodigo } = await validateCodigoDescuento(auxCodigo);

			console.log(idCodigo);

			NotificationManager.success("¡Código aplicado!");

			setCodigoAplicado(valido);

			setCodigoDescuento(auxCodigo);

			setPrecio(auxCodigo, precios, setPreciosXCodigo);

			setIdCodigoDescuento(idCodigo);
		} catch (error) {
			return NotificationManager.error("Este código es inválido");
		}
	};

	const establecerParametrosUrl = () => {
		
		if(compraExterna && compraLectura) {
			setUrlParams({
				...urlParams,
				urlParamsCancel: "?new-license=true&lectura=true"
			})
		}

		if(compraExterna && !compraLectura) {
			setUrlParams({
				...urlParams,
				urlParamsCancel: "?new-license=true&lectura=false"
			})
		}

		if(!compraExterna && compraLectura) {
			setUrlParams({
				...urlParams,
				urlParamsCancel: "?new-license=false&lectura=true"
			})
		}

		if(!compraExterna && !compraLectura) {
			setUrlParams({
				...urlParams,
				urlParamsCancel: "?new-license=false&lectura=false"
			})
		}
	}

	const handlePagarAhora = async () => {

		//*VERIFICAR QUE SE GENERE LA SESION DE STRIPE PARA EL CURSO DE LECTURA VELOZ
		try {
			
			if (valueRadioButton === "" && !compraLectura) {
				return NotificationManager.error("Elige una opción de pago");
			}
			setLoading(true);

			let stripeIdPrice = "";
			

			switch (valueRadioButton) {
				case typesOpcionesPagoCompra.contado:
				case typesOpcionesPagoCompra.msi:
					stripeIdPrice = preciosXCodigo.stripeIdPrice;
					break;

				case typesOpcionesPagoCompra.credito:
					stripeIdPrice = preciosXCodigo.credito.stripeIdPrice;
					break;

				default:
					break;
			}

			if(compraLectura) {
				stripeIdPrice = precios.lecturaVeloz.stripeIdPrice;
			}

			//todo:Revisar los datos que se envian para posteriormente hacer el rsgistro y luego generar el contrato.
			const sessionData = {
				success_url: `${window.location.origin}${dashboardRoutesPaths.pagos.compra.compraRealizada}${compraExterna ? "?license-acquired=true": `?license-acquired=false`}`,
				cancel_url: `${window.location.origin}${dashboardRoutesPaths.pagos.compra.compraLicencia}${urlParams.urlParamsCancel}`,
				line_items: [{ price: stripeIdPrice, quantity: 1 }],
				mode: "payment",
				currency: compraExterna ? "usd": "mxn",
				metadata: {
					folioContrato,
					metodoPago: compraLectura ? "contado" : valueRadioButton,
				},
			};


			const checkoutSession = await createCheckoutSession(sessionData);

			const { isConfirmed } = await Swal.fire({
				title: t('leavingClick'),
				text: t('leavingClickMessage'),
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonText: t('ok'),
				cancelButtonText: t('Cancel'),
				confirmButtonColor: "#0d6efd",
				allowOutsideClick: false,
			});

			if (!isConfirmed) {
				setLoading(false);

				return Notificacion("info", "El pago fue cancelado");
			}

			delete contextValue.preciosDescuento;

			setContextValue({
				...contextValue,
				compra: {
					...contextValue.compra,
					stripeSession: checkoutSession,
					codigoAplicado: compraLectura ? true : codigoAplicado,
					idCodigoDescuento: compraLectura ? precios.lecturaVeloz.idCodigo : idCodigoDescuento,
					preciosSeleccionados: preciosXCodigo,
					metodoPago: compraLectura ? "contado" :valueRadioButton,
				},
			});	

			setLoading(false);

			await (await stripe).redirectToCheckout({ sessionId: checkoutSession.id });
		} catch (error) {
			console.log("Error al obtener la información para generar el checkout: ", error);
		}
	};

	const handleChangeOpcionPago = ({ target }) => {
		setValueRadioButton(target.value);
	};

	const consultarFolioCompra = async () => {
		try {

			let folioContrato;

			if(compraLectura) {
				const {folioContrato: folio} = await getFolioContratoLecturaVeloz();
				folioContrato = folio
			}else{
				const { folioContrato: folio } = await getFolioContratoCompra();
				folioContrato = folio
			}

			console.log(folioContrato)
			setFolioContrato(folioContrato);

			setContextValue({
				...contextValue,
				compra: {
					...contextValue.compra,
					folioContrato,
				},
			});
		} catch (error) {
			console.log("error al obtener el folio de contrato: ", error);
		}
	};

	useEffect(() => {
		console.log(preciosXCodigo);
		if (folioContrato === "") {
			consultarFolioCompra();
			establecerParametrosUrl();
		}
	}, []);

	useEffect(() => {
		const { contado, msi, credito } = preciosXCodigo;

		console.log(preciosXCodigo)

		const auxOpcionesPago = [
			contado !== undefined && { value: "contado", label: "De Contado" },
			msi !== undefined && { value: "msi", label: "Meses sin intereses" },
			(credito !== undefined && !compraLectura) && { value: "credito", label: "A Crédito" },
		].filter(esValido);

		setOpcionesPago(auxOpcionesPago);
	}, [preciosXCodigo]);

	return (
		<Col sm={12} lg={8}>
			{!compraLectura ? (
				<div  className="formDescuentos w-100">
					<MUIFormControl>
					<FormLabel id="opciones-pago">Elige tu modalidad de pago</FormLabel>

					<RadioGroup aria-labelledby="opciones-pago" name="opcionPago" row value={valueRadioButton} onChange={handleChangeOpcionPago}>
						{opcionesPago.map(({ value, label }, idx) => (
							(!compraExterna || ((compraExterna && value !== 'msi') && (compraExterna && value !== 'credito'))) && 
							<FormControlLabel key={idx} value={value} control={<Radio />} label={label} />
						))}
					</RadioGroup>

					{valueRadioButton === "" ? (
						<Typography variant="caption" gutterBottom className="text-danger">
							Elige una opción de pago
						</Typography>
					) : null}
				</MUIFormControl>
				</div>
			): null}
			{convenio ? (
				<>

					<div class="stepper-wrapper mt-4">
						<div class="stepper-item completed active">
							<div class="step-counter">1</div>
							<div class="step-name">Registrate y obtén tu código de descuento</div>
						</div>
						<div class="stepper-item completed active ">
							<div class="step-counter">2</div>
							<div class="step-name">Realiza tu compra</div>
						</div>
						<div class="stepper-item ">
							<div class="step-counter">3</div>
							<div class="step-name">Completa el proceso de registro</div>
						</div>
						<div class="stepper-item">
							<div class="step-counter">4</div>
							<div class="step-name">Ingresa al curso</div>
						</div>
					</div>
					<Form className="formDescuentos" onSubmit={handleSubmitValidacionCodigo}>

						<div style={{ margin: '0 auto' }}>
							<Typography variant="overline" gutterBottom>
								Ingresa aquí tu código de descuento
							</Typography>

							<InputGroup className="mb-3">
								<FormControl className="mb-2 txtCodigoDescuento" name="codigoDescuento" onChange={handleInputChange} placeholder="Código de descuento" value={inputValue} disabled={codigoAplicado} />

								<Button className="mb-2" type="submit" variant="warning">
									Aplicar código
								</Button>
							</InputGroup>
						</div>

						<small className="text-info">Ingresa el código de descuento que recibiste en tu correo electrónico institucional.</small>

					</Form></>
			) : null}

			{compraLectura ? (
					<FormularioNuevaCompra 
					imgProducto={require("@assets/images/logo-gc-horizontal.png")} 
					precioProducto={codigoAplicado ? !convenio ? (preciosXCodigo.lecturaVeloz.contado) * 100 : (preciosXCodigo.lecturaVelozUveg.contado) * 100 : !convenio ? (preciosXCodigo.lecturaVeloz.contado) * 100 : (preciosXCodigo.lecturaVelozUveg.contado) * 100} 
					precioProductoUSD={15000} 
					nombreProducto={"Compra de curso de Lectura "} 
					compraExterna={compraExterna} 
					compraLectura={compraLectura}
					compraConvenio={convenio} 
					codigoConvenio={inputValue}
					compraKueski={compraExterna ? false : convenio ? false : true}
					folioContrato={folioContrato} 
					codigoAplicado={codigoAplicado} 
					precios={precios} 
					preciosXCodigo={preciosXCodigo} 
					valueRadioButton={valueRadioButton} 
					idCodigoDescuento={idCodigoDescuento} 
					successUrl={`${dashboardRoutesPaths.pagos.compra.compraLecturaVelozRealizada}${compraExterna ? "?license-acquired=true": `?license-acquired=false`}`}
					msiEnabled={false}
					/>
			): (
			<>
			<Form className="formDescuentos"  onSubmit={handleSubmitValidacionCodigo}>
				{!compraLectura ? (
					<div style={{margin: '0 auto'}}>
						<Typography variant="overline" gutterBottom>
							Ingresa aquí tu código de descuento
						</Typography>

						<InputGroup className="mb-3">
							<FormControl className="mb-2 txtCodigoDescuento" name="codigoDescuento" onChange={handleInputChange} placeholder="Código de descuento" value={inputValue} disabled={codigoAplicado} />

							<Button className="mb-2" type="submit" variant="warning">
								Aplicar código
							</Button>
						</InputGroup>	
					</div>
				): null}

				{/* <div className="d-grid gap-2">
					<Button onClick={handlePagarAhora} size="large" variant="orange-gc">
						Pagar ahora {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : null}
					</Button>
				</div> */}

			</Form>
				<Row className="justify-content-center">
					<Col className="col-lg-6">
						{valueRadioButton === "credito" && (
							<div className="d-grid gap-2">
								<Button onClick={handlePagarAhora} size="large" variant="orange-gc">
									Pagar ahora {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : null}
								</Button>
							</div>
						)}
					</Col>
				</Row>

				{valueRadioButton === "contado" ? (
					<FormularioNuevaCompra 
					imgProducto={require("@assets/images/click.png")} 
					precioProducto={preciosXCodigo.contado * 100} 
					precioProductoUSD={preciosXCodigo.contado * 100} 
					nombreProducto={"Compra de licencia Click+ "} 
					compraExterna={compraExterna} 
					compraLectura={compraLectura} 
					compraKueski={compraExterna ? false : true}
					folioContrato={folioContrato} 
					codigoAplicado={codigoAplicado} 
					precios={precios} 
					preciosXCodigo={preciosXCodigo} 
					valueRadioButton={valueRadioButton} 
					idCodigoDescuento={idCodigoDescuento} 
					successUrl={`${dashboardRoutesPaths.pagos.compra.compraRealizada}${compraExterna ? "?license-acquired=true": `?license-acquired=false`}`}
					msiEnabled={false}
					/>
				): null}

				{valueRadioButton === "msi" ? (
					<FormularioNuevaCompra 
					imgProducto={require("@assets/images/click.png")} 
					precioProducto={preciosXCodigo.msi.monto * 100} 
					precioProductoUSD={preciosXCodigo.msi.monto * 100} 
					nombreProducto={"Compra de licencia Click+ "} 
					compraExterna={compraExterna} 
					compraLectura={compraLectura} 
					compraKueski={false}
					folioContrato={folioContrato} 
					codigoAplicado={codigoAplicado} 
					precios={precios} 
					preciosXCodigo={preciosXCodigo} 
					valueRadioButton={valueRadioButton} 
					idCodigoDescuento={idCodigoDescuento} 
					successUrl={`${dashboardRoutesPaths.pagos.compra.compraRealizada}${compraExterna ? "?license-acquired=true": `?license-acquired=false`}`}
					msiEnabled={true}
					msiMax={12}
					/>
				): null}
			</>
			)}

			<Row className='justify-content-center'>
				<Col align={'center'} className='col-8 mt-5'>
					<p className="text-center">Si tienes dudas o problemas para realizar tu pago, puedes contactar a nuestro equipo de soporte técnico a los números:</p>
					<p className="text-center">Teléfono: <span className='text-warning'>477 314 59 75</span>, <span className='text-warning'>477 390 83 01</span> ext. 101</p>
					<p className="text-center">Correo: soporte@globalclickmexico.com</p>
				</Col>
			</Row>
		</Col>
	);
};

export default FormCodigoDescuento;
